import { useState } from 'react';

export default function useConfirm() {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState('');

  const showConfirm = (message: string) => {
    setConfirmMessage(message);
    setConfirmOpen(true);
  };

  const closeConfirm = () => {
    setConfirmOpen(false);
  };

  return { confirmOpen, confirmMessage, showConfirm, closeConfirm };
}

